import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  addCategory,
  editCategory,
  getCategory,
} from "../../features/slices/categoryManagement";
import Modal from "../Modal";
import { toastService } from "../../utils/toastify";

const EditCategory = ({ setUpdateState, categoryData }) => {
  const [formData, setFormData] = useState({
    categoryName: "",
    categoryType: "",
  });
  const [errors, setErrors] = useState({});
  const dispatch = useDispatch();

  const { categoryType, categoryName } = formData;

  useEffect(() => {
    setFormData({
      categoryName: categoryData?.categoryName || "",
      categoryType: categoryData?.categoryType || "",
    });
  }, []);
  const closeModal = () => {
    setUpdateState((prev) => ({ ...prev, editCategoryModal: false }));
  };
  const handleChange = (e) => {
    setErrors((prev) => ({ ...prev, [e.target.name]: "" }));
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  const validateForm = () => {
    let formErrors = {};
    let isValid = true;

    if (!categoryType?.trim()) {
      formErrors.categoryType = "categoryType is required.";
      isValid = false;
    }
    if (!categoryName?.trim()) {
      formErrors.categoryName = "categoryName is required.";
      isValid = false;
    }
    setErrors(formErrors);
    return isValid;
  };

  const handleCreateCategory = () => {
    const data = {
      id: categoryData?._id,
      categoryName: categoryName,
      categoryType: categoryType,
    };
    if (validateForm()) {
      dispatch(editCategory(data)).then((res) => {
        if (res?.payload?.code == 200) {
          toastService.success("Category edit successfully");
          dispatch(getCategory());
          closeModal();
        } else {
          toastService.error("Category edit failed");
        }
      });
    }
  };
  return (
    <Modal>
      <div className="modal-body">
        <div className="Category">
          <a className="CloseModal" onClick={closeModal}>
            ×
          </a>
          <h3>Edit Category</h3>
          <div className="form-group">
            <label>Category Type</label>
            {/* <select className="form-control">
                    <option>Select</option>
                    <option>Podcast</option>
                  </select> */}
            <input
              type="text"
              className="form-control"
              placeholder="Enter category name"
              name="categoryType"
              value={categoryType}
              onChange={handleChange}
            />
            {errors.categoryType && (
              <p className="d-flex justify-content-start text-danger mt-2 ">
                {errors.categoryType}
              </p>
            )}
          </div>
          <div className="form-group">
            <label>Category Name</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter category name"
              name="categoryName"
              value={categoryName}
              onChange={handleChange}
            />
            {errors.categoryName && (
              <p className="d-flex justify-content-start text-danger mt-2 ">
                {errors.categoryName}
              </p>
            )}
          </div>
          <button className="Button" onClick={handleCreateCategory}>
            Edit Category
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default EditCategory;
